import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import ButtonImportFileWebViewStyle from './ButtonImportFileWebViewStyle';
import ButtonImportFileWebViewModel from './ButtonImportFileWebViewModel';
import { View } from 'react-native';
import ButtonView from '../../../Both/Button/ButtonView';
export default class ButtonImportFileWebView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ButtonImportFileWebViewModel(this), new ButtonImportFileWebViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(View, { style: this.style.container },
            React.createElement(View, { style: this.style.hide },
                React.createElement("input", { type: 'file', ref: 'fileUploader', accept: this.props.accepted, onChange: (file) => { if (file.target.files != null) {
                        this.binding.handleFileChanged(file.target.files[0]);
                    } } })),
            React.createElement(ButtonView, { animation: 'None', borders: 'Rectangle', backgroundColor: this.props.buttonColor, textColor: this.props.textColor, handleClick: () => { this.binding.handleClick(); }, isLoading: false }, " import ")));
    }
}
